export default __webpack_public_path__ + "static/media/fm-icon.bbbd7824.svg";